import { useState } from "react";
import { Warning, Trash, CaretDown, CaretUp } from "@phosphor-icons/react";
import { formatEUR } from "../lib/format";

const ymText = (ym) => (ym && ym.length >= 7 ? `${ym.slice(5, 7)}/${ym.slice(0, 4)}` : "—");

const GroupItem = ({ it, onDelete }) => (
  <li className="flex items-center justify-between gap-3 py-2 border-b border-[#FDE7C7] last:border-0" data-testid={`dup-item-${it.id}`}>
    <div className="min-w-0">
      <div className="font-medium text-[#1F242E] truncate">{it.name}</div>
      <div className="text-[11px] text-[#5B6371]">
        {it.recurring ? `Wiederkehrend ab ${ymText(it.month)}${it.end_month ? ` bis ${ymText(it.end_month)}` : " (ohne Ende)"}` : `Einmalig ${ymText(it.eff)}`}
        {it.paid && ` · erledigt ${it.paid_date}`}
        {it.category && ` · ${it.category}`}
      </div>
    </div>
    <div className="flex items-center gap-3 shrink-0">
      <span className="font-display font-bold text-[#FF6B5C]">{formatEUR(it.amount)}</span>
      <button type="button" onClick={() => onDelete(it)}
        className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1.5 rounded-md border border-[#FF6B5C] text-[#FF6B5C] hover:bg-[#FF6B5C] hover:text-white transition-colors"
        data-testid={`dup-delete-${it.id}`}>
        <Trash size={12} /> Löschen
      </button>
    </div>
  </li>
);

export const ExpenseDuplicatePanel = ({ data, onDelete }) => {
  const [open, setOpen] = useState(true);
  if (!data || data.count === 0) return null;
  const over = data.groups.reduce((s, g) => s + (g.overcount || 0), 0);
  return (
    <div className="bg-[#FFF8EC] border border-[#F59E0B] rounded-lg p-4" data-testid="expense-duplicates-panel">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-left" data-testid="expense-duplicates-toggle">
        <div className="flex items-center gap-2">
          <Warning size={18} className="text-[#F59E0B]" weight="fill" />
          <span className="font-semibold text-[#1F242E]" data-testid="expense-duplicates-count">
            {data.count} mögliche Doppelung{data.count === 1 ? "" : "en"} gefunden
          </span>
          {over > 0 && <span className="text-sm text-[#5B6371]">· ca. {formatEUR(over)} zu viel gezählt</span>}
        </div>
        {open ? <CaretUp size={16} /> : <CaretDown size={16} />}
      </button>
      {open && (
        <div className="mt-3 space-y-3">
          {data.groups.map((g, i) => (
            <div key={i} className="bg-white border border-[#FDE7C7] rounded-md px-3 py-2" data-testid={`dup-group-${i}`}>
              <div className="text-xs font-medium text-[#B45309]">
                {g.label}{g.month ? ` · ${ymText(g.month)}` : ""}
              </div>
              <ul>{g.items.map((it) => <GroupItem key={it.id} it={it} onDelete={onDelete} />)}</ul>
            </div>
          ))}
          <p className="text-[11px] text-[#5B6371]">Tipp: Behalten Sie einen Eintrag und löschen Sie die Kopie. Bei „wiederkehrend + einmalig" ggf. ein Enddatum setzen statt zu löschen.</p>
        </div>
      )}
    </div>
  );
};
